(() => {
  const CLEAN_IMAGE = 'https://cdn.shopify.com/s/files/1/0680/9449/2936/files/sicilus-hero-estate-2026-clean.png?v=1786176494';
  const SECTION_TOKEN = 'hero_image_QaHNUM';
  const STYLE_ID = 'sicilus-summer-hero-2026-styles';
  const TRUST_TOKEN = 'shipping_9pXycT';
  const JUDGE_TOKEN = '1758134280b0210133';
  const COPY = {
    it:{rule:'La Regola Sicilus',claim:'Solo Sicilia, per scelta.',body:'Produttori, territori e specialità scelti secondo un criterio preciso.',cta:'Scopri la Regola →'},
    en:{rule:'The Sicilus Rule',claim:'Sicily only, by choice.',body:'Producers, territories and specialities selected according to a clear standard.',cta:'Discover the Rule →'},
    fr:{rule:'La Règle Sicilus',claim:'Seulement la Sicile, par choix.',body:'Producteurs, territoires et spécialités sélectionnés selon un critère précis.',cta:'Découvrir la Règle →'},
    de:{rule:'Die Sicilus-Regel',claim:'Nur Sizilien, aus Überzeugung.',body:'Produzenten, Regionen und Spezialitäten nach klaren Kriterien ausgewählt.',cta:'Die Regel entdecken →'},
    es:{rule:'La Regla Sicilus',claim:'Solo Sicilia, por elección.',body:'Productores, territorios y especialidades seleccionados con un criterio preciso.',cta:'Descubrir la Regla →'},
    pt:{rule:'A Regra Sicilus',claim:'Só Sicília, por escolha.',body:'Produtores, territórios e especialidades selecionados segundo um critério preciso.',cta:'Descobrir a Regra →'},
    nl:{rule:'De Sicilus-regel',claim:'Alleen Sicilië, bewust gekozen.',body:'Producenten, regio’s en specialiteiten geselecteerd volgens duidelijke criteria.',cta:'Ontdek de regel →'},
    no:{rule:'Sicilus-regelen',claim:'Bare Sicilia, med vilje.',body:'Produsenter, områder og spesialiteter valgt etter tydelige kriterier.',cta:'Oppdag regelen →'},
    sv:{rule:'Sicilus-regeln',claim:'Bara Sicilien, medvetet valt.',body:'Producenter, områden och specialiteter valda enligt tydliga kriterier.',cta:'Upptäck regeln →'},
    pl:{rule:'Zasada Sicilus',claim:'Tylko Sycylia, z wyboru.',body:'Producenci, regiony i specjalności wybrane według jasnych kryteriów.',cta:'Poznaj zasadę →'},
    cs:{rule:'Pravidlo Sicilus',claim:'Pouze Sicílie, z vlastní volby.',body:'Výrobci, regiony a speciality vybírané podle jasných kritérií.',cta:'Poznat pravidlo →'},
    hu:{rule:'A Sicilus szabálya',claim:'Csak Szicília, tudatos választásból.',body:'Termelők, tájak és különlegességek világos szempontok szerint válogatva.',cta:'A szabály megismerése →'},
    lt:{rule:'Sicilus taisyklė',claim:'Tik Sicilija, sąmoningas pasirinkimas.',body:'Gamintojai, vietovės ir produktai atrenkami pagal aiškius kriterijus.',cta:'Atrasti taisyklę →'},
    uk:{rule:'Правило Sicilus',claim:'Лише Сицилія — свідомий вибір.',body:'Виробники, території та спеціалітети, відібрані за чіткими критеріями.',cta:'Дізнатися про правило →'},
    ja:{rule:'Sicilusのルール',claim:'シチリアだけを、意志をもって。',body:'明確な基準で生産者、土地、特産品を選びます。',cta:'ルールを見る →'}
  };

  function lang(){ return (document.documentElement.lang || 'it').toLowerCase().split('-')[0]; }

  function ensureStyles(){
    if(document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"]{position:relative}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .hdt-content_wrap{display:none!important}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__overlay{position:absolute;inset:0;z-index:5;display:flex;align-items:center;pointer-events:none;background:linear-gradient(90deg,rgba(250,247,239,.74) 0%,rgba(250,247,239,.28) 40%,rgba(250,247,239,0) 62%)}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__copy{width:min(48vw,720px);margin-left:clamp(28px,6vw,120px);pointer-events:auto;color:#26311f}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__title{margin:0 0 18px;max-width:680px;font-family:Georgia,'Times New Roman',serif;font-weight:400;font-size:clamp(48px,4.15vw,78px);line-height:.98;letter-spacing:-.025em;color:#26311f}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__subtitle{margin:0 0 28px;max-width:680px;font-size:clamp(16px,1.15vw,20px);line-height:1.45;color:#394432}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__buttons{display:flex;flex-wrap:wrap;gap:12px}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__button{min-height:50px;display:inline-flex;align-items:center;justify-content:center;padding:0 25px;border:1px solid rgba(53,61,42,.18);border-radius:999px;background:rgba(249,244,235,.95);color:#28311f;font-size:13px;font-weight:600;letter-spacing:.08em;line-height:1.1;text-transform:uppercase;text-decoration:none}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__button:first-child{background:#53602f;border-color:#53602f;color:#fff!important}
      [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .hdt-hero-image img{object-position:center center!important}

      [id*="${JUDGE_TOKEN}"]{margin-block:0!important;padding-top:8px!important;padding-bottom:4px!important}
      [id*="${JUDGE_TOKEN}"] .shopify-app-block{margin-block:0!important;padding-block:4px!important}

      [id*="${TRUST_TOKEN}"]{margin-top:0!important;margin-bottom:0!important}
      [id*="${TRUST_TOKEN}"] .hdt-content-inner{padding-top:16px!important;padding-bottom:18px!important}
      [id*="${TRUST_TOKEN}"] .hdt-ship-item-wrap{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:10px;text-align:center}
      [id*="${TRUST_TOKEN}"] .hdt-ship-content{width:100%;max-width:270px;margin-inline:auto}
      [id*="${TRUST_TOKEN}"] .hdt-ship-content p{line-height:1.48!important}
      @media(min-width:1280px){
        [id*="${TRUST_TOKEN}"] .hdt-container{width:min(1380px,calc(100% - 64px))!important;max-width:1380px!important}
        [id*="${TRUST_TOKEN}"] .hdt-content-inner{padding-top:18px!important;padding-bottom:22px!important}
        [id*="${TRUST_TOKEN}"] .hdt-shipping-item{padding-inline:14px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-item-wrap{min-height:260px!important;padding:24px 20px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-icon img,[id*="${TRUST_TOKEN}"] .hdt-ship-icon svg{width:120px!important;height:120px!important;max-width:120px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-content p{font-size:15px!important;line-height:1.5!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-content > *:first-child p{font-size:14px!important;line-height:1.35!important;font-weight:650!important;letter-spacing:.045em!important}
      }
      @media(min-width:1536px){
        [id*="${TRUST_TOKEN}"] .hdt-container{width:min(1420px,calc(100% - 80px))!important;max-width:1420px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-item-wrap{min-height:270px!important;padding-inline:26px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-icon img,[id*="${TRUST_TOKEN}"] .hdt-ship-icon svg{width:120px!important;height:120px!important;max-width:120px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-content p{font-size:16px!important}
      }

      .sicilus-home-rule-band{margin:0!important;background:#173b2d!important;color:#fff8ea!important;border-top:1px solid rgba(255,255,255,.10)!important;border-bottom:1px solid rgba(255,255,255,.10)!important}
      .sicilus-home-rule-band__inner{width:min(1240px,calc(100% - 48px));margin:0 auto;display:grid;grid-template-columns:.8fr 1fr auto;gap:38px;align-items:center;padding:30px 0}
      .sicilus-home-rule-band .sicilus-home-rule-band__eyebrow{margin:0 0 6px!important;font-size:11px!important;font-weight:800!important;letter-spacing:.16em!important;text-transform:uppercase!important;color:#d2b86d!important}
      .sicilus-home-rule-band .sicilus-home-rule-band__claim{margin:0!important;font-family:Georgia,'Times New Roman',serif!important;font-size:clamp(30px,2.55vw,42px)!important;font-weight:400!important;line-height:1.04!important;color:#fff8ea!important}
      .sicilus-home-rule-band .sicilus-home-rule-band__body{margin:0!important;font-size:15px!important;line-height:1.55!important;color:rgba(255,248,234,.90)!important}
      .sicilus-home-rule-band .sicilus-home-rule-band__cta{display:inline-flex;white-space:nowrap;align-items:center;min-height:46px;padding:0 18px;border:1px solid rgba(255,248,234,.70)!important;color:#fff8ea!important;background:transparent!important;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;text-decoration:none}
      .sicilus-home-rule-band .sicilus-home-rule-band__cta:hover,.sicilus-home-rule-band .sicilus-home-rule-band__cta:focus-visible{background:#fff8ea!important;color:#173b2d!important}

      @media(max-width:1024px) and (min-width:768px){
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__copy{width:53vw;margin-left:36px}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__title{font-size:clamp(42px,5vw,58px)}
        .sicilus-home-rule-band__inner{grid-template-columns:1fr 1fr;gap:16px 28px}
        .sicilus-home-rule-band__cta{justify-self:start}
      }

      @media(max-width:767px){
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"]{background:#f6f0e5}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .hdt-hero-image img{object-position:72% center!important}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__overlay{position:relative;inset:auto;display:block;padding:24px 18px 30px;background:#f6f0e5}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__copy{width:100%;margin:0;text-align:center}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__title{margin:0 auto 12px;font-size:clamp(34px,10vw,46px);line-height:1.02}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__subtitle{margin:0 auto 20px;max-width:520px;font-size:15px}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__buttons{display:grid;grid-template-columns:1fr;gap:10px;max-width:430px;margin:0 auto}
        [id^="shopify-section-"][id*="${SECTION_TOKEN}"] .sicilus-summer-hero__button{width:100%;min-height:48px}

        [id*="${JUDGE_TOKEN}"]{padding-top:4px!important;padding-bottom:2px!important}
        [id*="${TRUST_TOKEN}"] .hdt-content-inner{padding-top:8px!important;padding-bottom:14px!important;overflow:visible!important}
        [id*="${TRUST_TOKEN}"] [id^="Scroller-"]{display:flex!important;grid-template-columns:none!important;gap:12px!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-snap-type:x mandatory!important;scroll-behavior:smooth;padding:0 46px 0 15px!important;scroll-padding-left:15px!important;scrollbar-width:none!important;-ms-overflow-style:none!important}
        [id*="${TRUST_TOKEN}"] [id^="Scroller-"]::-webkit-scrollbar{display:none!important}
        [id*="${TRUST_TOKEN}"] .hdt-shipping-item{flex:0 0 calc(100% - 44px)!important;width:calc(100% - 44px)!important;max-width:calc(100% - 44px)!important;scroll-snap-align:start!important;padding-inline:0!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-item-wrap{min-height:270px!important;padding:22px 18px 28px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-icon img,[id*="${TRUST_TOKEN}"] .hdt-ship-icon svg{width:116px!important;height:116px!important;max-width:116px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-content{max-width:260px!important}
        [id*="${TRUST_TOKEN}"] .hdt-ship-content p{font-size:15px!important;line-height:1.48!important}
        [id*="${TRUST_TOKEN}"] .hdt-shipping-dots{margin-top:12px!important;justify-content:center!important}
        [id*="${TRUST_TOKEN}"] .hdt-shipping-dot[aria-current="true"]{transform:scale(1.25)}

        .sicilus-home-rule-band__inner{width:min(calc(100% - 30px),1240px);grid-template-columns:1fr;gap:10px;padding:25px 0;text-align:center}
        .sicilus-home-rule-band .sicilus-home-rule-band__claim{font-size:clamp(30px,9vw,38px)!important}
        .sicilus-home-rule-band .sicilus-home-rule-band__body{font-size:14px!important}
        .sicilus-home-rule-band__cta{justify-content:center;margin-top:6px}
      }
    `;
    document.head.appendChild(style);
  }

  function replacePicture(section){
    const banner = section.querySelector('.hdt-hero-image');
    if(!banner) return;
    const old = banner.querySelector('.hdt-media-wrapper');
    if(!old) return;
    if(old.classList.contains('sicilus-summer-hero__media')){ section.classList.add('sicilus-summer-hero-ready'); return; }

    const existingImg = old.querySelector('img');
    const existingSrc = existingImg ? (existingImg.currentSrc || existingImg.src || '') : '';
    if(existingSrc.includes('sicilus-hero-estate-2026-clean.png')){
      old.classList.add('sicilus-summer-hero__media');
      section.classList.add('sicilus-summer-hero-ready');
      return;
    }

    const picture = document.createElement('picture');
    picture.className = 'hdt-media-wrapper sicilus-summer-hero__media';
    const img = document.createElement('img');
    img.src = CLEAN_IMAGE;
    img.srcset = CLEAN_IMAGE;
    img.sizes = '100vw';
    img.alt = 'Specialità siciliane Sicilus su terrazza estiva con vista sul mare';
    img.loading = 'eager';
    img.fetchPriority = 'high';
    const ready = () => section.classList.add('sicilus-summer-hero-ready');
    img.addEventListener('load',ready,{once:true});
    img.addEventListener('error',ready,{once:true});
    picture.appendChild(img);
    old.replaceWith(picture);
    if(img.complete) ready();
  }

  function buildOverlay(){
    const overlay = document.createElement('div');
    overlay.className = 'sicilus-summer-hero__overlay';
    overlay.innerHTML = `<div class="sicilus-summer-hero__copy"><h1 class="sicilus-summer-hero__title">L’estate ha il sapore della Sicilia</h1><p class="sicilus-summer-hero__subtitle">Box regalo, brioche e dolci artigianali per portare la Sicilia in tavola.</p><div class="sicilus-summer-hero__buttons" aria-label="Scopri le selezioni Sicilus"><a class="sicilus-summer-hero__button" href="/collections/box-degustazione-bundle-siciliani">Box degustazione</a><a class="sicilus-summer-hero__button" href="/collections/brioche-siciliane">Brioche siciliane</a><a class="sicilus-summer-hero__button" href="/collections/dolci-siciliani">Dolci siciliani</a></div></div>`;
    return overlay;
  }

  function restoreMedals(){
    const el = document.querySelector(`[id*="${JUDGE_TOKEN}"]`);
    if(el) el.style.removeProperty('display');
  }

  function insertRuleBand(){
    if(document.querySelector('.sicilus-home-rule-band')) return;
    const values = document.querySelector(`[id*="${TRUST_TOKEN}"]`);
    if(!values) return;
    const t = COPY[lang()] || COPY.en;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    const band = document.createElement('section');
    band.className = 'sicilus-home-rule-band';
    band.setAttribute('aria-label',t.rule);
    band.innerHTML = `<div class="sicilus-home-rule-band__inner"><div><p class="sicilus-home-rule-band__eyebrow">${t.rule}</p><p class="sicilus-home-rule-band__claim">${t.claim}</p></div><p class="sicilus-home-rule-band__body">${t.body}</p><a class="sicilus-home-rule-band__cta" href="${root}pages/la-regola-sicilus">${t.cta}</a></div>`;
    values.insertAdjacentElement('afterend',band);
  }

  let trustTimer = null;
  let trustResumeTimer = null;
  let trustScrollEnd = null;

  function initTrustCarousel(){
    const mobile = window.matchMedia('(max-width: 767px)');
    const section = document.querySelector(`[id*="${TRUST_TOKEN}"]`);
    if(!section || !mobile.matches) return;
    const scroller = section.querySelector('[id^="Scroller-"]');
    const items = Array.from(scroller ? scroller.querySelectorAll('.hdt-shipping-item') : []);
    const dots = Array.from(section.querySelectorAll('.hdt-shipping-dot'));
    if(!scroller || items.length < 2) return;
    if(section.dataset.sicilusAutoplay === 'true') return;
    section.dataset.sicilusAutoplay = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;

    function updateDots(){
      dots.forEach((dot,i) => {
        const active = i === index;
        dot.setAttribute('aria-current',active ? 'true' : 'false');
      });
    }

    function goTo(next,behavior='smooth'){
      index = (next + items.length) % items.length;
      const target = items[index];
      if(!target) return;
      const left = target.offsetLeft - scroller.offsetLeft;
      scroller.scrollTo({left,behavior});
      updateDots();
    }

    function stop(){
      if(trustTimer) clearInterval(trustTimer);
      trustTimer = null;
    }

    function start(){
      stop();
      if(reduceMotion || document.hidden || !mobile.matches) return;
      trustTimer = setInterval(() => {
        if(index >= items.length - 1) goTo(0,'auto');
        else goTo(index + 1,'smooth');
      },4300);
    }

    function pauseForUser(){
      stop();
      if(trustResumeTimer) clearTimeout(trustResumeTimer);
      trustResumeTimer = setTimeout(start,8000);
    }

    function syncIndexFromScroll(){
      if(trustScrollEnd) clearTimeout(trustScrollEnd);
      trustScrollEnd = setTimeout(() => {
        let nearest = 0;
        let distance = Infinity;
        items.forEach((item,i) => {
          const d = Math.abs((item.offsetLeft - scroller.offsetLeft) - scroller.scrollLeft);
          if(d < distance){ distance = d; nearest = i; }
        });
        index = nearest;
        updateDots();
      },120);
    }

    scroller.addEventListener('pointerdown',pauseForUser,{passive:true});
    scroller.addEventListener('touchstart',pauseForUser,{passive:true});
    scroller.addEventListener('scroll',syncIndexFromScroll,{passive:true});
    dots.forEach((dot,i) => dot.addEventListener('click',() => { pauseForUser(); goTo(i,'smooth'); }));
    document.addEventListener('visibilitychange',() => document.hidden ? stop() : start());
    updateDots();
    start();
  }

  function apply(root=document){
    ensureStyles();
    const sections = root.matches?.(`[id^="shopify-section-"][id*="${SECTION_TOKEN}"]`) ? [root] : Array.from(root.querySelectorAll?.(`[id^="shopify-section-"][id*="${SECTION_TOKEN}"]`) || []);
    sections.forEach(section => {
      section.classList.add('sicilus-summer-hero-2026');
      replacePicture(section);
      if(!section.querySelector('.sicilus-summer-hero__overlay')) section.appendChild(buildOverlay());
    });
    restoreMedals();
    insertRuleBand();
    initTrustCarousel();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => apply(document),{once:true});
  else apply(document);
  document.addEventListener('shopify:section:load',e => apply(e.target));
  document.addEventListener('shopify:section:select',e => apply(e.target));
})();
